import { render, staticRenderFns } from "./Bedankt.vue?vue&type=template&id=f80e8e7a"
import script from "./Bedankt.vue?vue&type=script&lang=js"
export * from "./Bedankt.vue?vue&type=script&lang=js"
import style0 from "./Bedankt.vue?vue&type=style&index=0&id=f80e8e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports